import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { Observable } from 'rxjs';
import { ISbComponentType } from 'storyblok-js-client';
import { StoryblokService } from '../services/storyblok.service';

export const storyblokRelationshipsResolver: ResolveFn<
  Observable<
    ISbStoryData<
      ISbComponentType<string> & {
        [index: string]: unknown;
      }
    >[]
  >
> = route => {
  const storyBlockService = inject(StoryblokService);
  return storyBlockService.resolveRelationships(route);
};
